
import gql from 'graphql-tag';
import { BaseService } from './BaseService';
import createChannelMessageMutation from '@/graphql/mutations/channel/message/Create.gql';
import createPartnerMembersChannelMutation
  from '@/graphql/mutations/channel/CreatePartnerMembersChannel.gql';
import updateChannelMutation from '@/graphql/mutations/channel/UpdateChannel.gql';
import { ChannelMessageInput } from '@/types/graphql/schemaTypes';

class ChannelService extends BaseService {
  public createChannelMessage(message: ChannelMessageInput, channelId: string) {
    return this.client.mutate({
      mutation: createChannelMessageMutation,
      variables: {
        message,
        channelId
      }
    });
  }

  public createPartnerMembersChannel(partnerMemberIds: string[], shipmentId: string) {
    return this.client.mutate({
      mutation: createPartnerMembersChannelMutation,
      variables: {
        partnerMemberIds,
        shipmentId
      }
    });
  }

  public updateChannel(channelId: string, partnerMemberIds: string[]) {
    return this.client.mutate({
      mutation: updateChannelMutation,
      variables: {
        channelId,
        partnerMemberIds
      }
    });
  }
}

export const channelService = new ChannelService();
